export default "__VITE_ASSET__BWZnxA1p__"